module.exports = __webpack_public_path__ + "static/media/aboutus-hero-1-alt.38e3f97c.jpg";